import Vue from 'vue'
import VueRouter from 'vue-router'
import dashboardRoutes from './dashboard'
import projectsRoutes from './projects'

Vue.use(VueRouter)

const routes = [
  ...dashboardRoutes,
  ...projectsRoutes,

  {
    path: '*', component: () => import('../views/404'),
    meta: {
      title: "404 - Not Found",
    }
  },

]

const router = new VueRouter({
  mode: 'history',
  routes
})

// This callback runs before every route change, including on page load.
router.beforeEach((to, _from, next) => {
  // This goes through the matched routes from last to first, finding the closest route with a title.
  // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);

  // Find the nearest route element with meta tags.
  const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);
  // const previousNearestWithMeta = from.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

  // If a route with a title was found, set the document (page) title to that value.
  if (nearestWithTitle) document.title = nearestWithTitle.meta.title;

  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el));

  // Skip rendering meta tags if there are none.
  if (!nearestWithMeta) return next();

  // Turn the meta tag definitions into actual elements in the head.
  nearestWithMeta.meta.metaTags.map(tagDef => {
    const tag = document.createElement('meta');

    Object.keys(tagDef).forEach(key => {
      tag.setAttribute(key, tagDef[key]);
    });

    // We use this to track which meta tags we create, so we don't interfere with other ones.
    tag.setAttribute('data-vue-router-controlled', '');

    return tag;
  })
    // Add the meta tags to the document head.
    .forEach(tag => document.head.appendChild(tag));

  next();
});


//Delete the customerId Param when the dealer leaves the CreateNewProject view
router.beforeEach((to, from, next) => {
  function hasQueryParams(route) {
    return !!Object.keys(route.query).length
  }

  if (to.meta?.isDashboardRoute) {
    let queryWithoutCustomerId = Object.assign({}, from.query);
    delete queryWithoutCustomerId.customerId;

    if (!hasQueryParams(to) && hasQueryParams(from)) {
      return next({ path: to.path, query: queryWithoutCustomerId });
    } else {
      return next()
    }
  } else {
    next()
  }
})


export default router
